"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Checkbox_1 = __importDefault(require("../common/Checkbox"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var react_i18next_1 = require("react-i18next");
var PrivateAccessModal_module_css_1 = __importDefault(require("./PrivateAccessModal.module.css"));
var AjaxProvider_1 = __importDefault(require("../../functions/AjaxProvider"));
var react_admin_1 = require("react-admin");
var q_play_core_1 = require("@nordicscreen/q-play-core");
var PrivateAccessModal = function (_a) {
    var isShown = _a.isShown, onClose = _a.onClose, type = _a.type, resourceId = _a.resourceId, resourceName = _a.resourceName;
    var t = (0, react_i18next_1.useTranslation)().t;
    var refresh = (0, react_admin_1.useRefresh)();
    var _b = (0, react_1.useState)([]), accessRows = _b[0], setAccessRows = _b[1];
    var _c = (0, react_1.useState)([]), initialAccessRows = _c[0], setInitialAccessRows = _c[1];
    var _d = (0, react_1.useState)([]), deletedAccessRows = _d[0], setDeletedAccessRows = _d[1];
    var logger = q_play_core_1.logManager.getLogger();
    (0, react_1.useEffect)(function () {
        var fetchExistingAccess = function () { return __awaiter(void 0, void 0, void 0, function () {
            var ajaxProvider, existingAccess, _a, rows, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!isShown)
                            return [2 /*return*/];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 9, , 10]);
                        ajaxProvider = (0, AjaxProvider_1.default)("/api");
                        existingAccess = void 0;
                        _a = type;
                        switch (_a) {
                            case "app": return [3 /*break*/, 2];
                            case "app-template": return [3 /*break*/, 4];
                            case "integration-template": return [3 /*break*/, 6];
                        }
                        return [3 /*break*/, 8];
                    case 2: return [4 /*yield*/, ajaxProvider.getAppAccess(resourceId)];
                    case 3:
                        existingAccess = _b.sent();
                        return [3 /*break*/, 8];
                    case 4: return [4 /*yield*/, ajaxProvider.getAppTemplateAccess(resourceId)];
                    case 5:
                        existingAccess = _b.sent();
                        return [3 /*break*/, 8];
                    case 6: return [4 /*yield*/, ajaxProvider.getIntegrationTemplateAccess(resourceId)];
                    case 7:
                        existingAccess = _b.sent();
                        return [3 /*break*/, 8];
                    case 8:
                        if (existingAccess === null || existingAccess === void 0 ? void 0 : existingAccess.data) {
                            rows = existingAccess.data.map(function (access) { return ({
                                id: Date.now() + Math.random(),
                                accountId: access.account_id.toString(),
                                access1: access.access === 1 || access.access === 2,
                                access2: access.access === 2,
                                existingAccess: true,
                            }); });
                            if (rows.length === 0) {
                                rows.push({
                                    id: Date.now(),
                                    accountId: "",
                                    access1: false,
                                    access2: false,
                                });
                            }
                            setAccessRows(rows);
                            setInitialAccessRows(rows);
                        }
                        return [3 /*break*/, 10];
                    case 9:
                        error_1 = _b.sent();
                        logger.error("Error fetching access:", error_1);
                        setAccessRows([{
                                id: Date.now(),
                                accountId: "",
                                access1: false,
                                access2: false,
                            }]);
                        setInitialAccessRows([]);
                        return [3 /*break*/, 10];
                    case 10: return [2 /*return*/];
                }
            });
        }); };
        fetchExistingAccess();
    }, [isShown, resourceId, type]);
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var ajaxProvider, updates, _a, error_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 8, , 9]);
                    ajaxProvider = (0, AjaxProvider_1.default)("/api");
                    updates = __spreadArray(__spreadArray([], accessRows
                        .filter(function (row) { return row.accountId; })
                        .filter(function (row) {
                        var initial = initialAccessRows.find(function (init) { return init.accountId === row.accountId; });
                        if (!initial)
                            return true;
                        if (initial.access1 !== row.access1 || initial.access2 !== row.access2)
                            return true;
                        return false;
                    })
                        .map(function (row) { return ({
                        accountId: parseInt(row.accountId, 10),
                        access: row.access2 ? 2 : row.access1 ? 1 : null,
                    }); }), true), deletedAccessRows.map(function (row) { return ({
                        accountId: parseInt(row.accountId, 10),
                        access: null,
                    }); }), true);
                    if (!(updates.length > 0)) return [3 /*break*/, 7];
                    _a = type;
                    switch (_a) {
                        case "app": return [3 /*break*/, 1];
                        case "app-template": return [3 /*break*/, 3];
                        case "integration-template": return [3 /*break*/, 5];
                    }
                    return [3 /*break*/, 7];
                case 1: return [4 /*yield*/, ajaxProvider.updateAppAccess(resourceId, updates)];
                case 2:
                    _b.sent();
                    refresh();
                    return [3 /*break*/, 7];
                case 3: return [4 /*yield*/, ajaxProvider.updateAppTemplateAccess(resourceId, updates)];
                case 4:
                    _b.sent();
                    refresh();
                    return [3 /*break*/, 7];
                case 5: return [4 /*yield*/, ajaxProvider.updateIntegrationTemplateAccess(resourceId, updates)];
                case 6:
                    _b.sent();
                    refresh();
                    return [3 /*break*/, 7];
                case 7:
                    onClose();
                    return [3 /*break*/, 9];
                case 8:
                    error_2 = _b.sent();
                    logger.error("Error saving access:", error_2);
                    return [3 /*break*/, 9];
                case 9: return [2 /*return*/];
            }
        });
    }); };
    var addNewRow = function () {
        setAccessRows(function (prev) { return __spreadArray(__spreadArray([], prev, true), [
            {
                id: Date.now(),
                accountId: "",
                access1: false,
                access2: false,
            }
        ], false); });
    };
    var removeRow = function (id) {
        setAccessRows(function (prev) {
            var rowToRemove = prev.find(function (row) { return row.id === id; });
            if (!rowToRemove)
                return prev;
            if (rowToRemove.existingAccess) {
                setDeletedAccessRows(function (deleted) { return __spreadArray(__spreadArray([], deleted, true), [rowToRemove], false); });
            }
            if (prev.length === 1) {
                return [{
                        id: Date.now(),
                        accountId: "",
                        access1: false,
                        access2: false,
                    }];
            }
            return prev.filter(function (row) { return row.id !== id; });
        });
    };
    var updateAccessRow = function (id, field, value) {
        setAccessRows(function (prev) { return prev.map(function (row) {
            var _a;
            if (row.id === id) {
                var updatedRow = __assign(__assign({}, row), (_a = {}, _a[field] = value, _a));
                if (field === "access1" && value === true) {
                    updatedRow.access2 = false;
                }
                if (field === "access2" && value === true) {
                    updatedRow.access1 = true;
                }
                else if (field === "access2" && value === false) {
                    updatedRow.access2 = false;
                }
                return updatedRow;
            }
            return row;
        }); });
    };
    var CustomHeader = (react_1.default.createElement("div", { className: "ns-font-family-bold", style: { fontSize: "25px" } },
        react_1.default.createElement("div", { style: { color: "var(--info-color)" } }, t("Manage private access")),
        resourceName && (react_1.default.createElement("div", { title: resourceName, style: {
                color: "var(--primary-color)",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "55%"
            } }, resourceName))));
    var body = (react_1.default.createElement("div", { style: { color: "var(--info-color)", marginTop: "-15px" }, className: PrivateAccessModal_module_css_1.default["body"] },
        react_1.default.createElement("div", { className: "".concat(PrivateAccessModal_module_css_1.default["heading-container"], " ns-font-family-bold") },
            react_1.default.createElement("div", { style: { flex: "0 0 47%" } }, t("Account Id")),
            react_1.default.createElement("div", { className: PrivateAccessModal_module_css_1.default["roles-heading-text"] },
                react_1.default.createElement("div", { title: "Private access" }, t("Access 1")),
                react_1.default.createElement("div", { title: "Private access & Developer Access" }, t("Access 2")))),
        react_1.default.createElement("div", { className: PrivateAccessModal_module_css_1.default["rows-container"] }, accessRows.map(function (row) { return (react_1.default.createElement("div", { key: row.id, className: PrivateAccessModal_module_css_1.default["access-row"] },
            react_1.default.createElement("div", { style: { maxWidth: "50%" } },
                react_1.default.createElement(q_play_components_1.Input, { type: "number", value: row.accountId, onChange: function (e) {
                        var inputValue = e.target.value;
                        if (/^\d*$/.test(inputValue)) {
                            updateAccessRow(row.id, "accountId", inputValue);
                        }
                    }, placeholder: t("Enter account ID"), className: PrivateAccessModal_module_css_1.default["account-input"] })),
            react_1.default.createElement("div", { className: PrivateAccessModal_module_css_1.default["checkbox-container"] },
                react_1.default.createElement(Checkbox_1.default, { checked: row.access1, onChange: function () { return updateAccessRow(row.id, "access1", !row.access1); } }),
                react_1.default.createElement(Checkbox_1.default, { checked: row.access2, onChange: function () { return updateAccessRow(row.id, "access2", !row.access2); } })),
            react_1.default.createElement(q_play_components_1.Button, { text: "-", onClick: function () { return removeRow(row.id); }, style: {
                    marginLeft: "auto",
                    marginRight: "6px",
                    padding: "0 5px",
                    borderRadius: "5px",
                    backgroundColor: "var(--secondary-color)",
                    color: "var(--info-color)",
                    maxWidth: "18px",
                    minWidth: "18px"
                } }))); })),
        react_1.default.createElement(q_play_components_1.Button, { onClick: addNewRow, className: PrivateAccessModal_module_css_1.default["add-team-button"], text: "+", style: { width: "100%" } })));
    var footer = (react_1.default.createElement("div", null,
        react_1.default.createElement(q_play_components_1.Button, { onClick: handleSave, text: t("Save") })));
    return (react_1.default.createElement(q_play_components_1.Modal, { isShown: isShown, onClose: onClose, centered: true, header: CustomHeader, body: body, footer: footer, dialogClassName: PrivateAccessModal_module_css_1.default["private-access-modal"] }));
};
exports.default = PrivateAccessModal;
